import { render, staticRenderFns } from "./IconCtrl.vue?vue&type=template&id=15948e07&"
import script from "./IconCtrl.vue?vue&type=script&lang=ts&"
export * from "./IconCtrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports